module.exports = __webpack_public_path__ + "h5/img/head3.eb50a8b8.png";